import React from 'react';
import { Link } from 'react-router-dom';
export const TeamPage = () => {
  const teamMembers = [{
    name: 'Alfred Chuang',
    title: 'General Partner',
    image: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/62e0202ed964cd704aad3b33_1590614887781.jpeg',
    slug: 'alfred-chuang'
  }, {
    name: 'Chris McCann',
    title: 'General Partner',
    image: 'https://uploads-ssl.webflow.com/62e0202ed964cdb8b5ad3acd/62e0202ed964cd1395ad3bae_Chris.png',
    slug: 'chris-mccann'
  }, {
    name: 'Edith Yeung',
    title: 'General Partner',
    image: 'https://uploads-ssl.webflow.com/62e0202ed964cdb8b5ad3acd/62e0202ed964cd85dead3b1d_1611126496277.jpeg',
    slug: 'edith-yeung'
  }, {
    name: 'Kelly Cheng',
    title: 'CFO',
    image: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/670e90e438f68b665e0edbe5_Untitled.png',
    slug: 'kelly-cheng'
  }, {
    name: 'Bernard Chan',
    title: 'Investor',
    image: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/67e17e811118b5f0ccc4a399_Bernard%20Profile.png',
    slug: 'bernard-chan'
  }, {
    name: 'Mohak Saxena',
    title: 'Investor',
    image: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/674ddd11189fcab109c08bf5_Screenshot%202024-12-02%20at%204.15.10%E2%80%AFPM.png',
    slug: 'mohak-saxena'
  }, {
    name: 'Matt McLaughlin',
    title: 'Senior Operating Partner',
    image: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/67812d6064cbde074e7c95ca_Untitled.png',
    slug: 'matt-mclaughlin'
  }, {
    name: 'Nick Dane',
    title: 'Capital Formation & IR',
    image: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/686ffac2c7ff3b519ea30cb7_ND%20PP.png',
    slug: 'nick-dane'
  }, {
    name: 'Tony Wong',
    title: 'EIR',
    image: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/651183f281964b9002aab8db_Tony-Wong-EIR.png',
    slug: 'tony-wong'
  }, {
    name: 'Elizabeth Candelaria',
    title: 'Senior EA & Office Manager',
    image: 'https://cdn.prod.website-files.com/62e0202ed964cdb8b5ad3acd/6501d75a036f656d0f3a3c6a_62e0202ed964cd8da9ad3b7f_Elizabeth-Candelaria-small.jpeg',
    slug: 'elizabeth-candelaria'
  }];
  return <div className="w-full bg-white" data-id="element-184">
      {/* Hero Section */}
      <section className="w-full py-20 px-6 md:px-12 bg-white" data-id="element-185">
        <div className="max-w-7xl mx-auto" data-id="element-186">
          <h1 className="text-4xl md:text-6xl font-bold text-[#070707] leading-tight mb-8" data-id="element-187">
            Our Team
          </h1>
          <p className="text-xl md:text-2xl text-[#070707] max-w-4xl mb-8" data-id="element-188">
            We're founders and operators who've built and scaled companies
            before. Our team brings decades of experience to help entrepreneurs
            navigate the challenges of building category-defining businesses.
          </p>
        </div>
      </section>
      {/* Team Members Section */}
      <section className="w-full py-16 px-6 md:px-12 bg-gray-50" data-id="element-189">
        <div className="max-w-7xl mx-auto" data-id="element-190">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-16" data-id="element-191">
            {teamMembers.map((member, index) => <div key={index} className="flex flex-col" data-id="element-192">
                <Link to={`/team/${member.slug}`} className="block" data-id="element-193">
                  <div className="relative mb-6 aspect-square overflow-hidden rounded-lg bg-gray-100 transition-transform hover:scale-[1.02]" data-id="element-194">
                    <img src={member.image} alt={member.name} className="w-full h-full object-cover" data-id="element-195" />
                  </div>
                  <h3 className="text-xl font-semibold text-[#070707] mb-1" data-id="element-196">
                    {member.name}
                  </h3>
                  <p className="text-red-600 font-medium" data-id="element-197">{member.title}</p>
                </Link>
              </div>)}
          </div>
        </div>
      </section>
      {/* Values Section */}
      <section className="w-full py-16 px-6 md:px-12 bg-white" data-id="element-198">
        <div className="max-w-7xl mx-auto" data-id="element-199">
          <h2 className="text-3xl font-bold text-[#070707] mb-10" data-id="element-200">
            Our Values
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-201">
            <div className="bg-gray-50 p-8 rounded-lg border border-gray-200" data-id="element-202">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-6" data-id="element-203">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-204">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-205" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3 text-[#070707]" data-id="element-206">
                Speed
              </h3>
              <p className="text-[#070707]" data-id="element-207">
                We move quickly and decisively. We understand that time is a
                founder's most valuable asset, and we respect that by making
                efficient decisions.
              </p>
            </div>
            <div className="bg-gray-50 p-8 rounded-lg border border-gray-200" data-id="element-208">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-6" data-id="element-209">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-210">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" data-id="element-211" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3 text-[#070707]" data-id="element-212">
                Partnership
              </h3>
              <p className="text-[#070707]" data-id="element-213">
                We view ourselves as partners in your journey, not just
                investors. We're committed to supporting founders through both
                successes and challenges.
              </p>
            </div>
            <div className="bg-gray-50 p-8 rounded-lg border border-gray-200" data-id="element-214">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-6" data-id="element-215">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-216">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" data-id="element-217" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3 text-[#070707]" data-id="element-218">
                Innovation
              </h3>
              <p className="text-[#070707]" data-id="element-219">
                We seek out founders with bold visions who are reimagining
                industries. We're not afraid to back ambitious ideas that others
                might consider too early or too risky.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Join Us Section */}
      <section className="w-full py-16 px-6 md:px-12 bg-gray-50" data-id="element-220">
        <div className="max-w-7xl mx-auto" data-id="element-221">
          <div className="bg-white rounded-xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between" data-id="element-222">
            <div className="mb-8 md:mb-0 md:mr-8" data-id="element-223">
              <h2 className="text-3xl font-bold text-[#070707] mb-4" data-id="element-224">
                Join Our Team
              </h2>
              <p className="text-lg text-[#070707] max-w-2xl" data-id="element-225">
                We're always looking for talented individuals who are passionate
                about helping founders build the next generation of
                category-defining companies.
              </p>
            </div>
            <button className="bg-red-600 hover:bg-red-700 text-white font-medium py-3 px-8 rounded-md transition-colors whitespace-nowrap" data-id="element-226">
              VIEW OPENINGS
            </button>
          </div>
        </div>
      </section>
    </div>;
};